export const TANI_SESSIONS = 'tru/TANI_SESSIONS'
export const TANI_PROJECTS = 'tru/TANI_PROJECT'

export const setTaniSessionsActions = payload => ({
  type: TANI_SESSIONS,
  payload 
})

export const setTaniProjectsActions = payload => ({
  type: TANI_PROJECTS,
  payload
})




// WEBPACK FOOTER //
// ../src/actions/taniSessionsActions.js